import { histories } from "@api/prescriptions/histories/path";

export const prescriptions = {
  histories,
};
